interface IProps {
  width?: number;
  height?: number;
  fillOpacity?: number;
  fillColor?: string;
}

export const CloseIcon = (props: IProps) => {
  const {width, height, fillOpacity, fillColor} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5858 12L5.79291 7.20706L7.20712 5.79285L12 10.5857L16.7929 5.79285L18.2071 7.20706L13.4142 12L18.2071 16.7928L16.7929 18.2071L12 13.4142L7.20712 18.2071L5.79291 16.7928L10.5858 12Z"
        fill={fillColor ? fillColor : "#FCFCFC"}
        fillOpacity={fillOpacity || 1}
      />
    </svg>)
} 